import React from 'react';

export default function SicBo2() {
    return (
        <div className="modal-dialog modal-xl">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="modal-title h4">Result</div>
                    <button type="button" className="btn-close" aria-label="Close" />
                </div>
                <div className="modal-body">
                    <div className="casino-result-modal">
                        <div className="casino-result-round-id">
                            <span>
                                <b>Round Id: </b> 158250516200828
                            </span>
                            <span>
                                <b>Match Time: </b>16/05/2025 20:08:28
                            </span>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12 text-center">
                                <div className="casino-result-cards">
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/dice1.png" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/dice2.png" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/dice3.png" />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2 justify-content-center">
                            <div className="col-md-6">
                                <div className="casino-result-desc">
                                    <div className="casino-result-desc-item">
                                        <div>Desc</div>
                                        <div>1,2,3</div>
                                    </div>
                                    <div className="casino-result-desc-item">
                                        <div>Win</div>
                                        <div>6</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
